import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, allTvSeries } from '@/mocks/tvSeries';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryName = currentCategory?.name || slug || '';

  const filteredSeries = slug
    ? allTvSeries.filter((item) => item.category === slug)
    : allTvSeries;

  return (
    <>
      <title>{`${categoryName} - 成全影视 | 免费高清在线观看`}</title>
      <meta name="description" content={`成全影视${categoryName}频道，提供最新${categoryName}全集免费在线观看，高清流畅不缓冲，免VIP看热门${categoryName}，每日更新最新剧集。`} />
      <meta name="keywords" content={`${categoryName},成全影视,${categoryName}在线观看,免费${categoryName},${categoryName}全集,高清${categoryName}`} />
      <link rel="canonical" href={`https://alu-expo-1.cn/category/${slug}`} />
      <meta property="og:title" content={`${categoryName} - 成全影视 | 免费高清在线观看`} />
      <meta property="og:description" content={`成全影视${categoryName}频道，提供最新${categoryName}全集免费在线观看，高清流畅不缓冲。`} />
      <meta property="og:url" content={`https://alu-expo-1.cn/category/${slug}`} />
      <meta property="og:type" content="website" />

      <main className="min-h-screen bg-background-50 pt-16">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb
            items={[
              { label: categoryName, href: `/category/${slug}` },
            ]}
          />

          <div className="mt-6 mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              {categoryName}
            </h1>
            <p className="text-sm text-foreground-500">
              共 {filteredSeries.length} 部{categoryName}，高清流畅不缓冲，免费在线观看
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
            <Link
              to="/"
              className="whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
            >
              {t('all')}
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full transition-all cursor-pointer flex items-center gap-1.5 ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredSeries.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">{t('noResult')}</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
              {filteredSeries.map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-2.5">
                    <img
                      src={item.coverImage}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                      loading="lazy"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="px-1.5 py-0.5 bg-primary-500 text-white text-[10px] font-bold rounded">
                        {item.rating}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2">
                      <span className="text-[10px] text-white/80">{item.updateInfo}</span>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
    </>
  );
}